export const URL_BASE =
  process.env.NODE_ENV === 'development' ? 'http://localhost:4505' : 'https://oc-back.tienda-sportfitness.com';

export const URL_BASE_IM =
  process.env.NODE_ENV === 'development' ? 'http://localhost:4506' : 'https://stock-back.tienda-sportfitness.com';

// http://localhost:4506
export const URL_FRONT =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://qcode-frontend-automatization-oc.vercel.app';

export const URL_CREATE_ACCOUNT = `${URL_BASE}/api/v1/accounts`;

export const URL_REGISTER_ACCOUNT = `${URL_BASE}/Register`;

export const URL_LOGIN = `${URL_BASE}/api/v1/auth/login`;
export const URL_ORDERS = `${URL_BASE}/api/v1/Orders`;
export const URL_CONFIGURE_SHIPPING_CARRIER = `${URL_BASE}/api/v1/ConfigurationShippingCarrier`;

export const URL_SHIPPING_CARRIER_VALIDATE_CONFIGURATION = `${URL_CONFIGURE_SHIPPING_CARRIER}/isConfigurationComplete`;

export const URL_SHIPPING = `${URL_BASE}/api/v1/coordinadoraWs`;
export const URL_WAREHOUSE = `${URL_BASE}/api/v1/Warehouses`;

export const URL_SCHEDULE_PICKUP = `${URL_BASE}/api/v1/SchedulePickup`;

export const URL_CITIES = `${URL_BASE}/api/v1/Cities`;
export const URL_PACKAGES = `${URL_BASE}/api/v1/Packages`;
export const URL_PAYMENT_TYPES = `${URL_BASE}/api/v1/paymentTypes`;
export const URL_USER_PAYMENT_TYPES = `${URL_BASE}/api/v1/users/paymentTypes`;
export const URL_GENERATE_PDF_TRACKING_NUMBERS = `${URL_BASE}/api/v1/coordinadoraWs/GeneratePDFOfTrackingNumbers`;
export const URL_PURCHASE_ORDERS = `${URL_BASE}/api/v1/oc`;
export const URL_ORDER_DELIVERY = `${URL_BASE}/api/v1/qr-delivery`;
export const URL_DISPATCHES_REPORTS = `${URL_BASE}/api/v1/reports/dispatches`;
export const URL_CROSSING_INVOICES = `${URL_BASE}/api/v1/crossing-invoices`;

// Inventory Managmemnt
export const URL_WAREHOUSE_IM = `${URL_BASE_IM}/api/v1/Warehouses`;
export const URL_CATEGORIES_IM = `${URL_BASE_IM}/api/v1/Categories`;
export const URL_PROVIDERS_IM = `${URL_BASE_IM}/api/v1/Providers`;
export const URL_PRODUCTS_IM = `${URL_BASE_IM}/api/v1/Products`;
export const URL_MOVEMENT_IM = `${URL_BASE_IM}/api/v1/movement`;
export const URL_LOGIN_IM = `${URL_BASE_IM}/api/v1/auth/login`;
